export default __webpack_public_path__ + "static/media/white_logo.e79f6fcb.svg";